import React, { Component } from 'react';
import Utils from '../../utils.js'
import ReactTooltip from 'react-tooltip'

class GitURL extends Component {

	//lambda ensures correct 'this' scope
	onChange = (e) => {
		let adGroup = this.fetchAdGroup(Utils.getProjectNameFromGitUrl(e.target.value));
		this.props.updateStore({
			gitURL: e.target.value,
			consumerName: Utils.constructConsumerOrProxyGroupName(e.target.value),
			adGroup: adGroup
		});
	}

	onChangeConsumer = (e) => {	
		this.props.updateStore({
			consumerName: e.target.value
		});
	}
	
	fetchAdGroup = (project) => {
		return fetch(`https://api.theprincipal.net/retirement/v1/metrics/metadata/public/project/${project}/property?name=adminADGroup`,
			{
				headers:{
					'Content-Type': 'text/plain'
				}
			})
			.then(res => {
				if(!res.ok){
					throw Error(res.statusText);
				}
				return res.text();
			})
			.then(text => {
				
				this.props.updateStore({
					adGroup: text
				});
				
			})
			.catch(err => {
				throw Error(err);
			})
	}

	render() {
		let data = this.props.getStore();
		return <div>
			<div className="container">
				<div className="row">
					<div className="col-md-8">
						<br/>
						<label htmlFor="gitURL">Git URL of the application that will be making REST calls:</label>
						<input className="form-control" id="gitURL" name="gitURL" value={data.gitURL} onChange={this.onChange} placeholder="ssh://git@scm.principal.com:7999/risdvlp/maven-archetype-rest-template.git" />
					</div>
				</div>
				<div className="row">
					<br/>
					<div className="col-md-2">
						<label htmlFor="consumerPrefix" className="is-required">Consumer Prefix:</label>
						<span className="tooltipCustomReact" data-tip data-for='consumerPrefix'> ? </span>
						<ReactTooltip id="consumerPrefix" effect='solid' place='right'>
								<span>Which is typically [BU]-[SubBu]_ E.G. RIS-FSA_ or RIS-BANK_</span>
						</ReactTooltip>
						<input className="form-control" id="consumerPrefix" value={Utils.constructProxyGroupPrefix(data.subBU)}/>
					</div>				
					<div className="col-md-6">
						<label htmlFor="consumerName" className="is-required">Consumer Name:</label>
						<span className="tooltipCustomReact" data-tip data-for='consumerName'> ? </span>
						<ReactTooltip id="consumerName" effect='solid' place='right'>
								<span>Prefix has been added for you so please do not include it here. <br/>Consumer Name or Developer Application is typically just the [reponame]. E.G. git@github.com:principalris-emu/<b>[</b><i>integrate-aws-cli-scripts</i><b>]</b>.git</span>
						</ReactTooltip>
						<input className="form-control" id="consumerName" value={data.consumerName} onChange={this.onChangeConsumer}/>
					</div>
				</div>
			</div>
		</div>
	}
}

export default GitURL;